<template>
    <div>
        <div
            ref="chat"
            class="chart-wrapper mb-4">
            <ul class="is-flex is-flex-direction-column">
                <li
                    :key="uniqId"
                    v-for="{ id: uniqId, comment, creator: { id, login, intId }, createdAt } of data"
                    class="is-flex is-relative mb-2"
                    :class="{ 'is-flex-direction-row-reverse': id === selfId }">
                    <div class="chart-triangle">
                        &#9698;
                    </div>
                    <div class="chart-item">
                        <span
                            v-html="defineLinksInString(comment)"
                            class="text"></span>
                        <div class="is-size-7 mt-1 has-text-grey">
                            {{ login }} [{{ intId }}]: {{ moment(createdAt, "DD.MM.YY HH:mm") }}
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div
            v-if="!viewOnly"
            class="flex is-align-items-center">
            <LInput
                v-model="comment"
                type="textarea"
                expanded
                :maxlength="maxLength"
                @keyup.enter.exact.native="sendMessage">
            </LInput>
            <b-button
                class="ml-2 mb-4 p-4"
                style="border: none; background-color: white"
                icon-left="paper-plane"
                :disabled="!comment.length && !sending"
                :type="!!comment && !sending ? 'is-info is-light' : undefined"
                :loading="sending"
                size="is-large"
                @click="sendMessage">
            </b-button>
        </div>
    </div>
</template>

<script>
  import { SET_EMPTY } from "@core/store/mutation-constants";
  import { ADD_TRAFFIC_COMPLAINT_COMMENT, GET_TRAFFIC_COMPLAINT_COMMENTS } from "@core/store/action-constants";
  import { mapActions, mapMutations, mapState } from "vuex";
  import { formatEmptyString, moment } from "@core/filters";
  import { defineLinksInString } from "@core/helpers/defineLinksInString";

  export default {
    name: "LChat",

    props: {
      loading: {
        type: Boolean,
        default: false
      },

      viewOnly: {
        type: Boolean,
        default: false
      },

      sending: {
        type: Boolean,
        default: false
      },

      maxLength: {
        type: Number,
        default: 2000
      },

      data: {
        type: Array,
        default: () => []
      }
    },

    data () {
      return {
        isSending: false,
        comment: ""
      };
    },

    computed: {
      ...mapState("admin/profile", {
        selfId: ({ user }) => user.id
      })
    },

    methods: {
      defineLinksInString,
      ...mapActions("admin/complaints/complaintsChatModal", {
        ADD_TRAFFIC_COMPLAINT_COMMENT,
        GET_TRAFFIC_COMPLAINT_COMMENTS
      }),

      ...mapMutations("admin/complaints/complaintsChatModal", {
        SET_EMPTY
      }),

      sendMessage () {
        this.$emit("send", this.comment);
        this.comment = "";
      },

      convertPeriod ([start, end]) {
        return start ? `${ moment(start, "DD.MM.YYYY") } - ${ moment(end, "DD.MM.YYYY") }` : formatEmptyString(null);
      },

      moment
    },

    watch: {
      data () {
        setTimeout(() => {
          this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight;
        }, 0);
      }
    }
  };
</script>

<style scoped lang="scss">
$color-primary: #fbf1df;

.chart {
    $self: &;

    &-wrapper {
        border: 1px solid $light;
        border-radius: .5rem;
        height: 50vh;
        overflow: hidden;
        overflow-y: auto;
        padding: .5rem 1rem;
        background: transparentize(#000, .98);

        .text {
            white-space: pre-wrap;
        }

        @include touch {
            height: 50vh;
        }

        @include mobile {
            height: 40vh;
        }

        .is-flex-direction-row-reverse {
            #{ $self }-triangle {
                transform: scale(-1, 1);
                left: auto;
                right: -11px;
                color: $color-primary;
            }

            #{ $self }-item {
                border-bottom-left-radius: 1rem;
                border-bottom-right-radius: 0;
                background-color: $color-primary;
            }
        }
    }

    &-triangle {
        position: absolute;
        bottom: -7px;
        left: -11px;
        text-shadow: 0 0 10px rgba(172, 172, 172, 0.25);
        color: $white-gray;
    }

    &-item {
        width: max-content;
        padding: .3rem .6rem;
        border: 1px solid $light-light;
        box-shadow: 0 0 10px rgba(172, 172, 172, 0.25);
        border-top-left-radius: 1rem;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }
}

::v-deep {
    .textarea {
        min-height: 6em;
    }
}
</style>